import type { User } from "../contexts/AuthContext";

/**
 * Resolves the provider id the authenticated user owns, tolerating the three shapes the auth
 * payload can take (`providerId`, `provider.id`, `userProviders[0].providerId`). Returns null when
 * the user owns no provider. Use this everywhere ownership is decided so the redirect, layout
 * choice, and edit gate all agree.
 */
export function getOwnProviderId(user: User | null | undefined): string | null {
  if (!user) return null;
  return user.providerId || user.provider?.id || user.userProviders?.[0]?.providerId || null;
}
